import { StatusBadgeTarget } from '@euler/app/components/StatusBadge';
import { WiredHeaderView } from '@euler/app/tv/components/detail/HeaderView';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo, ReactNode } from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

export const TaskScreenContent = memo(
  ({
    children,
    targetStatus,
    style,
  }: {
    children?: ReactNode;
    targetStatus?: StatusBadgeTarget;
    style?: StyleProp<ViewStyle>;
  }) => {
    const { bottom } = useSafeAreaInsets();
    const { rpx } = useResponsiveContext();

    return (
      <View
        css={`
          flex: 1;
          padding-bottom: ${Math.max(bottom, rpx(16))}px;
        `}
        style={style}
      >
        {/** header  */}
        <WiredHeaderView targetStatus={targetStatus} />

        {children}
      </View>
    );
  },
);
